import React, { memo } from "react";
import PropTypes from "prop-types";
import { Message } from "react-message-context";
import { UNIDENTIFIED } from "../../utils/enums";

const Info = memo(({ customerType }) => {
  return (
    <div className="rof-info">
      <h2 className="rof-info__title">
        <Message id="info.title" />
      </h2>
      <ol>
        <li>
          <Message id="info.list.item1" />
        </li>
        <li>
          <Message id="info.list.item2" />
        </li>
        <li>
          <Message id="info.list.item3" />
        </li>
        <li>
          <Message
            id={`info.list.item4.${
              customerType === UNIDENTIFIED ? "anonymous" : "loggedIn"
            }`}
          />
        </li>
      </ol>
    </div>
  );
});

Info.propTypes = {
  customerType: PropTypes.string.isRequired,
};

export default Info;
